export default interface TipoAtendimentoModel {
    name?: string;
    descricao?: string;
}

export const tiposAtendimentoList:TipoAtendimentoModel[] = [
    { name: "CONSULTA", descricao: "Consulta" },
    { name: "EXAME", descricao: "Exame" },
    { name: "PROCEDIMENTO", descricao: "Procedimento" },
    { name: "CIRURGIA", descricao: "Cirurgia" },
    { name: "REMOCAO", descricao: "Remoção" },
]